import {NgModule} from '@angular/core';
import {FileUploadComponent} from './file-upload.component';

@NgModule({
    declarations: [FileUploadComponent],
    exports: [FileUploadComponent]
})
export class FileUploadModule {
}
